import { useRef, useEffect } from "react";

/**
 * Autoplay muted looping video with image poster fallback.
 * Used for "dynamic" media on the home page.
 */
export default function MediaVideo({ src, poster, className = "", testid }) {
  const ref = useRef(null);

  // Some browsers block autoplay until interaction — make sure it tries.
  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    const tryPlay = () => v.play().catch(() => {});
    tryPlay();
  }, [src]);

  return (
    <video
      ref={ref}
      data-testid={testid}
      className={className}
      src={src}
      poster={poster}
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      aria-hidden="true"
    />
  );
}
